import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../utils/helper';

export const pollPageClasses = generateClasses('PollPage', ['questionForm']);

export const Content = styled((props: StackProps) => <Stack gap={2} {...props} />)(({ theme }) => ({
  overflow: 'hidden',
  [`& .${pollPageClasses.questionForm}`]: {
    flex: 1,
    overflow: 'hidden',
  },
}));
